import { _axios } from "../../../Utils/Axios/axios";

export const requestPdfFileService = async (
  userToken: string,
  questions: string[],
  lessonId: string | number,
  subjectId: string | number
) => {
  const data = new FormData();

  data.append("q", questions.toString());
  data.append("lesson_id", String(lessonId));
  data.append("subject_id", String(subjectId));

  return _axios.post("/request/pdf", data, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
